import React from "react"
import { Link } from "gatsby"

import Subscribe from "./Subscribe"

const Footer = () => (
  <footer>
    <section className="bg-white text-center mx-auto align-center">
      <h3 className="mt-10 pt-10 text-xl">Invitan</h3>
      <div className="w-1/2 mx-auto flex justify-center justify-items-center items-center">
        <img
          src="/images/logo-13.png"
          height="150px"
          width="150px"
          style={{ width: 150, height: 150 }}
          alt="Canal 13"
          className="mr-10"
        />
        <img
          src="/images/ministerio-economia.png"
          height="107px"
          width="107px"
          style={{ width: 107, height: 107 }}
          alt="Ministerio de Economía, Fomento y Turismo"
        />

        <img src="/images/min-digitaliza-pyme.png" alt="Digitaliza tu Pyme" />
      </div>
    </section>
    <section className="bg-gray-200 pt-10 pb-10">
      <div className="w-full md:max-w-7xl mx-auto md:grid grid-cols-1 md:grid-cols-5 items-center">
        <div
          className="border-0 md:border-r-2 border-gray-700 grid grid-cols-1 items-center pt-10 md:pt-0 pb-10 md:pb-0"
          style={{ height: "80%" }}
        >
          <img
            src="./images/logo-gris.svg"
            alt="Denda"
            width={150}
            className="block mx-auto"
          />
        </div>
        <div
          className="grid grid-cols-2 border-0 md:border-r-2 border-gray-700 px-6"
          style={{ height: "80%" }}
        >
          <div className="col-span-2 text-center">
            <h3>Organizan</h3>
          </div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://denda.cl/?utm_source=navidadpyme&utm_medium=navidadpyme&utm_campaign=organizers&utm_term=main-page&utm_content=public-page"
            title="Denda"
          >
            <img src="./images/denda-sqr.svg" alt="Denda" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://symlab.io/?utm_source=navidadpyme&utm_medium=welcome&utm_campaign=organizers&utm_term=welcome_page&utm_content=pre-launch"
            title="Symmetrics Lab"
          >
            <img src="./images/sym-sqr.svg" alt="Symmetrics Lab" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://thewildfoods.com/?utm_source=navidadpyme&utm_medium=welcome&utm_campaign=organizers&utm_term=welcome_page&utm_content=pre-launch"
            title="Wild Foods"
          >
            <img src="./images/wfood-sqr.svg" alt="Wild Foods" />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://servisenior.com/?utm_source=navidadpyme&utm_medium=welcome&utm_campaign=organizers&utm_term=welcome_page&utm_content=pre-launch"
            title="ServiSenior"
          >
            <img
              src="./images/ss-sqr.svg"
              alt="ServiSenior"
              style={{ width: 74, marginLeft: 16, marginTop: 16 }}
            />
          </a>
        </div>
        <div
          className="col-span-2 grid grid-cols-1 border-0 md:border-r-2 border-gray-700 px-6"
          style={{ height: "80%" }}
        >
          <div className="text-center">
            <h3 className="mb-5">Suscríbete a nuestras novedades</h3>
          </div>
          <Subscribe />
        </div>
        <div className="px-6" style={{ height: "80%" }}>
          <div className="text-center">
            <h3>Links</h3>
          </div>
          <div className="ml-0 md:ml-5 mt-5">
            <p>
              <Link to="/nosotros">Quienes somos</Link>
            </p>
            <p>
              <Link to="/terminos">Términos y condiciones</Link>
            </p>
            <p>
              <Link to="/faq">Preguntas frecuentes</Link>
            </p>
            <p>
              <a href="https://navidadpyme-symlab.s3.amazonaws.com/toolkitNavidadPyme.zip">
                Material Gráfico
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </footer>
)

export default Footer
